import React,{useEffect, useState} from 'react'
import {Row, Col, Nav, Accordion,} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, getCandidateProfileStatus } from '../../actions/candidatesActions'
import { Link, useLocation } from 'react-router-dom'
import { getScheduledInterviewsByCandidate, getScheduledInterviewsQuantityByCandidate } from '../../actions/choosesActions'
import Version from '../../version'


export default function MenuCandidate() {
    const { t } = useTranslation()
	const {client, logout} = useAuth()
    const dispatch = useDispatch()
	const location = useLocation()

	const activeTitlesPaths = [
		'/candidate/profile/officialtitles',
		'/candidate/profile/courses'
	]
	const isActiveTitles = activeTitlesPaths.includes(location.pathname)

	const activeSkillsPaths = [
		'/candidate/profile/competences',
		'/candidate/profile/languages',
		'/candidate/profile/technologies',
		'/candidate/profile/methodologies'
	]
	const isActiveSkills = activeSkillsPaths.includes(location.pathname)


	const {candidate, candidateuser, candidateStatus} = useSelector(state=>state.candidates)

	const [imageAux, setImage] = useState(null)
	useEffect(() => {
        if(client){
            dispatch(getCandidate(client?.id))
			dispatch(getCandidateProfileStatus(client?.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(candidate){
            setImage(candidateuser.image)
        }
    },[candidate, candidateuser])

	useEffect(() => {
		if (location.pathname === '/candidate/profile' || activeTitlesPaths.includes(location.pathname) || location.pathname === '/candidate/profile/careerpath' || activeSkillsPaths.includes(location.pathname) || location.pathname === '/candidate/actual') {
			setActiveKey('0')
		} else {
			setActiveKey(null)
		}
	// eslint-disable-next-line
	}, [location])

	const [activeKey, setActiveKey] = useState(null)

	const handleToggle = (eventKey) => {
		setActiveKey(activeKey === eventKey ? null : eventKey)
	}

	const refreshCalendar = () => {
		if (client) {
			dispatch(getScheduledInterviewsQuantityByCandidate(client.id))
			dispatch(getScheduledInterviewsByCandidate(client.id))
		}
	}
  	return (
		<>
			<Row>
				<Col xs='12' className='d-flex justify-content-center mt-3 mb-2'>
					<div className='avatar'>
						{imageAux
							?
								<img className="img-profile" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
							:
								<div className="img-profile"></div>
						}
					</div>
				</Col>
				<Col className='text-center'>
						{candidate?.firstname} {candidate?.lastname}
				</Col>
			</Row>
			<Row>
				<Col className='d-flex justify-content-center align-items-center gap-2'>
					<Link onClick={refreshCalendar} to="/candidate/config">
						<img src='/images/config.svg' alt="Config" />
					</Link>
					<Link to="/" onClick={logout}>
						<i className="fa-solid fa-arrow-right-from-bracket color-primary"></i>
					</Link>
				</Col>
			</Row>
			<Row style={{ marginTop: '100px'}}>
				<Col className='p-0'>
					<Nav className="flex-column">
						<Nav.Item>
							<Link onClick={refreshCalendar} to="/candidate/dashboard" className='nav-link'>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Accordion>
								<Accordion.Item eventKey="0" className="ps-2">
									<Accordion.Header onClick={() => handleToggle("0")}>
										<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.profile')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/home" className="flex-column">
											<Nav.Item>
												<Link
													onClick={refreshCalendar} 
													to="/candidate/profile"														
													className={`nav-link ${location.pathname === '/candidate/profile' ? 'active' : ''}`}
												>
													<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
													{t('menus.myprofile')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link
													onClick={refreshCalendar} 
													to="/candidate/profile/officialtitles"
													className={`nav-link ${isActiveTitles ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 1 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/titulos.svg" alt="Icono Titulos Academicos" className='me-3' />
													{t('menus.academic')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link
													onClick={refreshCalendar} 
													to="/candidate/profile/careerpath" 
													className={`nav-link ${location.pathname === '/candidate/profile/careerpath' ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 2 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/experiencia.svg" alt="Icono Experiencia Laboral" className='me-3' />
													{t('menus.professional')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link
													onClick={refreshCalendar} 
													to="/candidate/profile/competences" 
													className={`nav-link ${isActiveSkills ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 3 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/habilidades.svg" alt="Icono Habilidades" className='me-3' />
													{t('menus.skills')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link onClick={refreshCalendar} 
													to="/candidate/profile/ideal-position"
													className={`nav-link ${location.pathname === '/candidate/profile/ideal-position' ? 'active' : ''} ${candidateStatus === 'completed' ? '' : 'disabled'}`}
												>
													<img src="/images/menus/idealPosition.svg" alt="Icono puesto ideal" className='me-3' />
													{t('menus.idealPosition')}
												</Link>
											</Nav.Item>
											{/* <Nav.Item>
												<Link
													onClick={refreshCalendar}
													to="/candidate/actual"
													className={`nav-link ${location.pathname === '/candidate/actual' ? 'active' : ''}`}
												>
													<img src="/images/menus/puestoactual.svg" alt="Icono Puesto Actual" className='me-3' />
													{t('menus.actual')}
												</Link>
											</Nav.Item> */}
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						<Nav.Item>
							<Link onClick={refreshCalendar} to="/candidate/active-processes" className='nav-link'>
								<img src="/images/menus/processes.svg" alt="Procesos" className='me-3'/>
								{t('menus.candidateProcesses')}
							</Link>
						</Nav.Item>
						{/* <Nav.Item>
							<Link onClick={refreshCalendar} to="/candidate/job-portal" className='nav-link'>
								<img src="/images/menus/portalempleo.svg" alt="Portal de empleo" className='me-3'/>
								{t('menus.jobPortal')}
							</Link>
						</Nav.Item> */}
						<Nav.Item>
							<Link onClick={refreshCalendar} to="/candidate/tickets" className='nav-link'>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
						<Nav.Item></Nav.Item>
					</Nav>

				</Col>
			</Row>
			<Row>
				<Col className='text-center my-3'>
					<Version/>
				</Col>
			</Row>
		</>
	)
}